/* tslint:disable */
/* eslint-disable */
/**
 * SALESTA API Service
 * Open API
 *
 * The version of the OpenAPI document: v1
 * Contact: admin@salesta.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountVO
 */
export interface AccountVO {
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'account'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'accountNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'address1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'address3'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'bankTransferBranchName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'bankTransferName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'depositTypeCategoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountVO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'payeeKatakanaName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'payeeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'postCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'printedPayeeName2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'printedPaymentDestinationName1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'salesOfficeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'telephoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountVO
     */
    'tempPass'?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordParam
 */
export interface ChangePasswordParam {
    /**
     * newPassword
     * @type {string}
     * @memberof ChangePasswordParam
     */
    'newPassword': string;
    /**
     * OTP
     * @type {number}
     * @memberof ChangePasswordParam
     */
    'otp': number;
    /**
     * userId
     * @type {string}
     * @memberof ChangePasswordParam
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ForgotParam
 */
export interface ForgotParam {
    /**
     * 
     * @type {string}
     * @memberof ForgotParam
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ForgotParam
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface ForgotUserIdParam
 */
export interface ForgotUserIdParam {
    /**
     * 
     * @type {string}
     * @memberof ForgotUserIdParam
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface LoginParam
 */
export interface LoginParam {
    /**
     * 
     * @type {string}
     * @memberof LoginParam
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginParam
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface MessageVO
 */
export interface MessageVO {
    /**
     * 
     * @type {number}
     * @memberof MessageVO
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageVO
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface OAuth2AccessToken
 */
export interface OAuth2AccessToken {
    /**
     * 
     * @type {object}
     * @memberof OAuth2AccessToken
     */
    'additionalInformation'?: object;
    /**
     * 
     * @type {string}
     * @memberof OAuth2AccessToken
     */
    'expiration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OAuth2AccessToken
     */
    'expired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OAuth2AccessToken
     */
    'expiresIn'?: number;
    /**
     * 
     * @type {OAuth2RefreshToken}
     * @memberof OAuth2AccessToken
     */
    'refreshToken'?: OAuth2RefreshToken;
    /**
     * 
     * @type {Array<string>}
     * @memberof OAuth2AccessToken
     */
    'scope'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OAuth2AccessToken
     */
    'tokenType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2AccessToken
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface OAuth2RefreshToken
 */
export interface OAuth2RefreshToken {
    /**
     * 
     * @type {string}
     * @memberof OAuth2RefreshToken
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface RefreshParam
 */
export interface RefreshParam {
    /**
     * 
     * @type {string}
     * @memberof RefreshParam
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface RegistrationParam
 */
export interface RegistrationParam {
    /**
     * user\'s email
     * @type {string}
     * @memberof RegistrationParam
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof RegistrationParam
     */
    'otp'?: number;
    /**
     * password
     * @type {string}
     * @memberof RegistrationParam
     */
    'password': string;
    /**
     * userId
     * @type {string}
     * @memberof RegistrationParam
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ResendOtpParam
 */
export interface ResendOtpParam {
    /**
     * user\'s email
     * @type {string}
     * @memberof ResendOtpParam
     */
    'email': string;
    /**
     * userId
     * @type {string}
     * @memberof ResendOtpParam
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface ResponseEntity
 */
export interface ResponseEntity {
    /**
     * 
     * @type {object}
     * @memberof ResponseEntity
     */
    'body'?: object;
    /**
     * 
     * @type {string}
     * @memberof ResponseEntity
     */
    'statusCode'?: ResponseEntityStatusCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof ResponseEntity
     */
    'statusCodeValue'?: number;
}

export const ResponseEntityStatusCodeEnum = {
    _100Continue: '100 CONTINUE',
    _101SwitchingProtocols: '101 SWITCHING_PROTOCOLS',
    _102Processing: '102 PROCESSING',
    _103Checkpoint: '103 CHECKPOINT',
    _200Ok: '200 OK',
    _201Created: '201 CREATED',
    _202Accepted: '202 ACCEPTED',
    _203NonAuthoritativeInformation: '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent: '204 NO_CONTENT',
    _205ResetContent: '205 RESET_CONTENT',
    _206PartialContent: '206 PARTIAL_CONTENT',
    _207MultiStatus: '207 MULTI_STATUS',
    _208AlreadyReported: '208 ALREADY_REPORTED',
    _226ImUsed: '226 IM_USED',
    _300MultipleChoices: '300 MULTIPLE_CHOICES',
    _301MovedPermanently: '301 MOVED_PERMANENTLY',
    _302Found: '302 FOUND',
    _302MovedTemporarily: '302 MOVED_TEMPORARILY',
    _303SeeOther: '303 SEE_OTHER',
    _304NotModified: '304 NOT_MODIFIED',
    _305UseProxy: '305 USE_PROXY',
    _307TemporaryRedirect: '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect: '308 PERMANENT_REDIRECT',
    _400BadRequest: '400 BAD_REQUEST',
    _401Unauthorized: '401 UNAUTHORIZED',
    _402PaymentRequired: '402 PAYMENT_REQUIRED',
    _403Forbidden: '403 FORBIDDEN',
    _404NotFound: '404 NOT_FOUND',
    _405MethodNotAllowed: '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable: '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired: '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout: '408 REQUEST_TIMEOUT',
    _409Conflict: '409 CONFLICT',
    _410Gone: '410 GONE',
    _411LengthRequired: '411 LENGTH_REQUIRED',
    _412PreconditionFailed: '412 PRECONDITION_FAILED',
    _413PayloadTooLarge: '413 PAYLOAD_TOO_LARGE',
    _413RequestEntityTooLarge: '413 REQUEST_ENTITY_TOO_LARGE',
    _414UriTooLong: '414 URI_TOO_LONG',
    _414RequestUriTooLong: '414 REQUEST_URI_TOO_LONG',
    _415UnsupportedMediaType: '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable: '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed: '417 EXPECTATION_FAILED',
    _418IAmATeapot: '418 I_AM_A_TEAPOT',
    _419InsufficientSpaceOnResource: '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420MethodFailure: '420 METHOD_FAILURE',
    _421DestinationLocked: '421 DESTINATION_LOCKED',
    _422UnprocessableEntity: '422 UNPROCESSABLE_ENTITY',
    _423Locked: '423 LOCKED',
    _424FailedDependency: '424 FAILED_DEPENDENCY',
    _426UpgradeRequired: '426 UPGRADE_REQUIRED',
    _428PreconditionRequired: '428 PRECONDITION_REQUIRED',
    _429TooManyRequests: '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge: '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons: '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError: '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented: '501 NOT_IMPLEMENTED',
    _502BadGateway: '502 BAD_GATEWAY',
    _503ServiceUnavailable: '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout: '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported: '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates: '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage: '507 INSUFFICIENT_STORAGE',
    _508LoopDetected: '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded: '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended: '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired: '511 NETWORK_AUTHENTICATION_REQUIRED'
} as const;

export type ResponseEntityStatusCodeEnum = typeof ResponseEntityStatusCodeEnum[keyof typeof ResponseEntityStatusCodeEnum];

/**
 * 
 * @export
 * @interface UserVO
 */
export interface UserVO {
    /**
     * 
     * @type {AccountVO}
     * @memberof UserVO
     */
    'account'?: AccountVO;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'accountStatus'?: UserVOAccountStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UserVO
     */
    'createdAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserVO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserVO
     */
    'lastLoginAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserVO
     */
    'userId'?: string;
}

export const UserVOAccountStatusEnum = {
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Invalid: 'INVALID',
    Unknown: 'UNKNOWN'
} as const;

export type UserVOAccountStatusEnum = typeof UserVOAccountStatusEnum[keyof typeof UserVOAccountStatusEnum];


/**
 * ForgotPasswordControllerApi - axios parameter creator
 * @export
 */
export const ForgotPasswordControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Forgot Password
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ForgotParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgetPasswordUsingPOST: async (authorization: string, xTenantID: string, param: ForgotParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('forgetPasswordUsingPOST', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('forgetPasswordUsingPOST', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('forgetPasswordUsingPOST', 'param', param)
            const localVarPath = `/api/v1/open/forgot-password/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForgotPasswordControllerApi - functional programming interface
 * @export
 */
export const ForgotPasswordControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForgotPasswordControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Forgot Password
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ForgotParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgetPasswordUsingPOST(authorization: string, xTenantID: string, param: ForgotParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgetPasswordUsingPOST(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ForgotPasswordControllerApi - factory interface
 * @export
 */
export const ForgotPasswordControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForgotPasswordControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Forgot Password
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ForgotParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgetPasswordUsingPOST(authorization: string, xTenantID: string, param: ForgotParam, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.forgetPasswordUsingPOST(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForgotPasswordControllerApi - object-oriented interface
 * @export
 * @class ForgotPasswordControllerApi
 * @extends {BaseAPI}
 */
export class ForgotPasswordControllerApi extends BaseAPI {
    /**
     * 
     * @summary Forgot Password
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {ForgotParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgotPasswordControllerApi
     */
    public forgetPasswordUsingPOST(authorization: string, xTenantID: string, param: ForgotParam, options?: AxiosRequestConfig) {
        return ForgotPasswordControllerApiFp(this.configuration).forgetPasswordUsingPOST(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ForgotUserIdControllerApi - axios parameter creator
 * @export
 */
export const ForgotUserIdControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Forgot UserId
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ForgotUserIdParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgetUserIdUsingPOST: async (authorization: string, xTenantID: string, param: ForgotUserIdParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('forgetUserIdUsingPOST', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('forgetUserIdUsingPOST', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('forgetUserIdUsingPOST', 'param', param)
            const localVarPath = `/api/v1/open/forgot-userid/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForgotUserIdControllerApi - functional programming interface
 * @export
 */
export const ForgotUserIdControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForgotUserIdControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Forgot UserId
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ForgotUserIdParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgetUserIdUsingPOST(authorization: string, xTenantID: string, param: ForgotUserIdParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgetUserIdUsingPOST(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ForgotUserIdControllerApi - factory interface
 * @export
 */
export const ForgotUserIdControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForgotUserIdControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Forgot UserId
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ForgotUserIdParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgetUserIdUsingPOST(authorization: string, xTenantID: string, param: ForgotUserIdParam, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.forgetUserIdUsingPOST(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForgotUserIdControllerApi - object-oriented interface
 * @export
 * @class ForgotUserIdControllerApi
 * @extends {BaseAPI}
 */
export class ForgotUserIdControllerApi extends BaseAPI {
    /**
     * 
     * @summary Forgot UserId
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {ForgotUserIdParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgotUserIdControllerApi
     */
    public forgetUserIdUsingPOST(authorization: string, xTenantID: string, param: ForgotUserIdParam, options?: AxiosRequestConfig) {
        return ForgotUserIdControllerApiFp(this.configuration).forgetUserIdUsingPOST(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthControllerApi - axios parameter creator
 * @export
 */
export const HealthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/open/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthControllerApi - functional programming interface
 * @export
 */
export const HealthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthControllerApi - factory interface
 * @export
 */
export const HealthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthUsingGET(options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.healthUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthControllerApi - object-oriented interface
 * @export
 * @class HealthControllerApi
 * @extends {BaseAPI}
 */
export class HealthControllerApi extends BaseAPI {
    /**
     * 
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthControllerApi
     */
    public healthUsingGET(options?: AxiosRequestConfig) {
        return HealthControllerApiFp(this.configuration).healthUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginControllerApi - axios parameter creator
 * @export
 */
export const LoginControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {LoginParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: async (authorization: string, xTenantID: string, param: LoginParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('loginUsingPOST', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('loginUsingPOST', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('loginUsingPOST', 'param', param)
            const localVarPath = `/api/v1/open/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginControllerApi - functional programming interface
 * @export
 */
export const LoginControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Login
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {LoginParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUsingPOST(authorization: string, xTenantID: string, param: LoginParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuth2AccessToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUsingPOST(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginControllerApi - factory interface
 * @export
 */
export const LoginControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Login
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {LoginParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST(authorization: string, xTenantID: string, param: LoginParam, options?: any): AxiosPromise<OAuth2AccessToken> {
            return localVarFp.loginUsingPOST(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginControllerApi - object-oriented interface
 * @export
 * @class LoginControllerApi
 * @extends {BaseAPI}
 */
export class LoginControllerApi extends BaseAPI {
    /**
     * 
     * @summary Login
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {LoginParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginControllerApi
     */
    public loginUsingPOST(authorization: string, xTenantID: string, param: LoginParam, options?: AxiosRequestConfig) {
        return LoginControllerApiFp(this.configuration).loginUsingPOST(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RefreshControllerApi - axios parameter creator
 * @export
 */
export const RefreshControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary refresh token
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RefreshParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshUsingPUT: async (authorization: string, xTenantID: string, param: RefreshParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('refreshUsingPUT', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('refreshUsingPUT', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('refreshUsingPUT', 'param', param)
            const localVarPath = `/api/v1/open/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefreshControllerApi - functional programming interface
 * @export
 */
export const RefreshControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefreshControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary refresh token
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RefreshParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshUsingPUT(authorization: string, xTenantID: string, param: RefreshParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuth2AccessToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshUsingPUT(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RefreshControllerApi - factory interface
 * @export
 */
export const RefreshControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefreshControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary refresh token
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RefreshParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshUsingPUT(authorization: string, xTenantID: string, param: RefreshParam, options?: any): AxiosPromise<OAuth2AccessToken> {
            return localVarFp.refreshUsingPUT(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefreshControllerApi - object-oriented interface
 * @export
 * @class RefreshControllerApi
 * @extends {BaseAPI}
 */
export class RefreshControllerApi extends BaseAPI {
    /**
     * 
     * @summary refresh token
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {RefreshParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefreshControllerApi
     */
    public refreshUsingPUT(authorization: string, xTenantID: string, param: RefreshParam, options?: AxiosRequestConfig) {
        return RefreshControllerApiFp(this.configuration).refreshUsingPUT(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegistrationControllerApi - axios parameter creator
 * @export
 */
export const RegistrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RegistrationParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUsingPOST: async (authorization: string, xTenantID: string, param: RegistrationParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('confirmUsingPOST', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('confirmUsingPOST', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('confirmUsingPOST', 'param', param)
            const localVarPath = `/api/v1/open/registration/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RegistrationParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST6: async (authorization: string, xTenantID: string, param: RegistrationParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createUsingPOST6', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('createUsingPOST6', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('createUsingPOST6', 'param', param)
            const localVarPath = `/api/v1/open/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} xTenantID tenantID
         * @param {string} password 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET8: async (authorization: string, xTenantID: string, password: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('detailUsingGET8', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('detailUsingGET8', 'xTenantID', xTenantID)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('detailUsingGET8', 'password', password)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('detailUsingGET8', 'userId', userId)
            const localVarPath = `/api/v1/open/registration/{userId}/{password}`
                .replace(`{${"password"}}`, encodeURIComponent(String(password)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend OTP
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ResendOtpParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOtpUsingPOST: async (authorization: string, xTenantID: string, param: ResendOtpParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resendOtpUsingPOST', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('resendOtpUsingPOST', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('resendOtpUsingPOST', 'param', param)
            const localVarPath = `/api/v1/open/registration/resend-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationControllerApi - functional programming interface
 * @export
 */
export const RegistrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RegistrationParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmUsingPOST(authorization: string, xTenantID: string, param: RegistrationParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmUsingPOST(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RegistrationParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsingPOST6(authorization: string, xTenantID: string, param: RegistrationParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsingPOST6(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} xTenantID tenantID
         * @param {string} password 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detailUsingGET8(authorization: string, xTenantID: string, password: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detailUsingGET8(authorization, xTenantID, password, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend OTP
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ResendOtpParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOtpUsingPOST(authorization: string, xTenantID: string, param: ResendOtpParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOtpUsingPOST(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationControllerApi - factory interface
 * @export
 */
export const RegistrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RegistrationParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUsingPOST(authorization: string, xTenantID: string, param: RegistrationParam, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.confirmUsingPOST(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {RegistrationParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST6(authorization: string, xTenantID: string, param: RegistrationParam, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.createUsingPOST6(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization 
         * @param {string} xTenantID tenantID
         * @param {string} password 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailUsingGET8(authorization: string, xTenantID: string, password: string, userId: string, options?: any): AxiosPromise<UserVO> {
            return localVarFp.detailUsingGET8(authorization, xTenantID, password, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend OTP
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ResendOtpParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOtpUsingPOST(authorization: string, xTenantID: string, param: ResendOtpParam, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.resendOtpUsingPOST(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationControllerApi - object-oriented interface
 * @export
 * @class RegistrationControllerApi
 * @extends {BaseAPI}
 */
export class RegistrationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {RegistrationParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public confirmUsingPOST(authorization: string, xTenantID: string, param: RegistrationParam, options?: AxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).confirmUsingPOST(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {RegistrationParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public createUsingPOST6(authorization: string, xTenantID: string, param: RegistrationParam, options?: AxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).createUsingPOST6(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization 
     * @param {string} xTenantID tenantID
     * @param {string} password 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public detailUsingGET8(authorization: string, xTenantID: string, password: string, userId: string, options?: AxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).detailUsingGET8(authorization, xTenantID, password, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend OTP
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {ResendOtpParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public resendOtpUsingPOST(authorization: string, xTenantID: string, param: ResendOtpParam, options?: AxiosRequestConfig) {
        return RegistrationControllerApiFp(this.configuration).resendOtpUsingPOST(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StorageOpenControllerApi - axios parameter creator
 * @export
 */
export const StorageOpenControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllInactiveUserCredential
         * @param {string} tenantId tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInactiveUserCredentialUsingGET1: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllInactiveUserCredentialUsingGET1', 'tenantId', tenantId)
            const localVarPath = `/api/v1/open/storage/user-guidance/{tenantId}/userGuidance.zip`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} fileName fileName
         * @param {string} tenantId tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileWithMediaTypeUsingGET2: async (fileName: string, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getFileWithMediaTypeUsingGET2', 'fileName', fileName)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getFileWithMediaTypeUsingGET2', 'tenantId', tenantId)
            const localVarPath = `/api/v1/open/storage/{tenantId}/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getInactiveUserCredentialByIds
         * @param {string} tenantId tenantId
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInactiveUserCredentialByIdsUsingGET1: async (tenantId: string, userIds: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getInactiveUserCredentialByIdsUsingGET1', 'tenantId', tenantId)
            // verify required parameter 'userIds' is not null or undefined
            assertParamExists('getInactiveUserCredentialByIdsUsingGET1', 'userIds', userIds)
            const localVarPath = `/api/v1/open/storage/user-guidance/{tenantId}/{userIds}/userGuidance.zip`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userIds"}}`, encodeURIComponent(String(userIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getInitialCredentialByUserId
         * @param {string} tenantId tenantId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialCredentialByUserIdUsingGET1: async (tenantId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getInitialCredentialByUserIdUsingGET1', 'tenantId', tenantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getInitialCredentialByUserIdUsingGET1', 'userId', userId)
            const localVarPath = `/api/v1/open/storage/user-guidance/{tenantId}/{userId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageOpenControllerApi - functional programming interface
 * @export
 */
export const StorageOpenControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageOpenControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllInactiveUserCredential
         * @param {string} tenantId tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInactiveUserCredentialUsingGET1(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInactiveUserCredentialUsingGET1(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} fileName fileName
         * @param {string} tenantId tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileWithMediaTypeUsingGET2(fileName: string, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileWithMediaTypeUsingGET2(fileName, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getInactiveUserCredentialByIds
         * @param {string} tenantId tenantId
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInactiveUserCredentialByIdsUsingGET1(tenantId: string, userIds: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInactiveUserCredentialByIdsUsingGET1(tenantId, userIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getInitialCredentialByUserId
         * @param {string} tenantId tenantId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialCredentialByUserIdUsingGET1(tenantId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialCredentialByUserIdUsingGET1(tenantId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StorageOpenControllerApi - factory interface
 * @export
 */
export const StorageOpenControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageOpenControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllInactiveUserCredential
         * @param {string} tenantId tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInactiveUserCredentialUsingGET1(tenantId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getAllInactiveUserCredentialUsingGET1(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getFileWithMediaType
         * @param {string} fileName fileName
         * @param {string} tenantId tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileWithMediaTypeUsingGET2(fileName: string, tenantId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFileWithMediaTypeUsingGET2(fileName, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getInactiveUserCredentialByIds
         * @param {string} tenantId tenantId
         * @param {string} userIds userIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInactiveUserCredentialByIdsUsingGET1(tenantId: string, userIds: string, options?: any): AxiosPromise<string> {
            return localVarFp.getInactiveUserCredentialByIdsUsingGET1(tenantId, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getInitialCredentialByUserId
         * @param {string} tenantId tenantId
         * @param {string} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialCredentialByUserIdUsingGET1(tenantId: string, userId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getInitialCredentialByUserIdUsingGET1(tenantId, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageOpenControllerApi - object-oriented interface
 * @export
 * @class StorageOpenControllerApi
 * @extends {BaseAPI}
 */
export class StorageOpenControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllInactiveUserCredential
     * @param {string} tenantId tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageOpenControllerApi
     */
    public getAllInactiveUserCredentialUsingGET1(tenantId: string, options?: AxiosRequestConfig) {
        return StorageOpenControllerApiFp(this.configuration).getAllInactiveUserCredentialUsingGET1(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getFileWithMediaType
     * @param {string} fileName fileName
     * @param {string} tenantId tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageOpenControllerApi
     */
    public getFileWithMediaTypeUsingGET2(fileName: string, tenantId: string, options?: AxiosRequestConfig) {
        return StorageOpenControllerApiFp(this.configuration).getFileWithMediaTypeUsingGET2(fileName, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getInactiveUserCredentialByIds
     * @param {string} tenantId tenantId
     * @param {string} userIds userIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageOpenControllerApi
     */
    public getInactiveUserCredentialByIdsUsingGET1(tenantId: string, userIds: string, options?: AxiosRequestConfig) {
        return StorageOpenControllerApiFp(this.configuration).getInactiveUserCredentialByIdsUsingGET1(tenantId, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getInitialCredentialByUserId
     * @param {string} tenantId tenantId
     * @param {string} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageOpenControllerApi
     */
    public getInitialCredentialByUserIdUsingGET1(tenantId: string, userId: string, options?: AxiosRequestConfig) {
        return StorageOpenControllerApiFp(this.configuration).getInitialCredentialByUserIdUsingGET1(tenantId, userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UpdatePasswordControllerApi - axios parameter creator
 * @export
 */
export const UpdatePasswordControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change Password
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ChangePasswordParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordUsingPOST: async (authorization: string, xTenantID: string, param: ChangePasswordParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changePasswordUsingPOST', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('changePasswordUsingPOST', 'xTenantID', xTenantID)
            // verify required parameter 'param' is not null or undefined
            assertParamExists('changePasswordUsingPOST', 'param', param)
            const localVarPath = `/api/v1/open/verify-forgot-password/verify-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(param, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {number} otp 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOTPUsingGET: async (authorization: string, xTenantID: string, otp: number, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('verifyOTPUsingGET', 'authorization', authorization)
            // verify required parameter 'xTenantID' is not null or undefined
            assertParamExists('verifyOTPUsingGET', 'xTenantID', xTenantID)
            // verify required parameter 'otp' is not null or undefined
            assertParamExists('verifyOTPUsingGET', 'otp', otp)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('verifyOTPUsingGET', 'userId', userId)
            const localVarPath = `/api/v1/open/verify-forgot-password/{user_id}/verify-otp/{otp}`
                .replace(`{${"otp"}}`, encodeURIComponent(String(otp)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTenantID !== undefined && xTenantID !== null) {
                localVarHeaderParameter['X-TenantID'] = String(xTenantID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdatePasswordControllerApi - functional programming interface
 * @export
 */
export const UpdatePasswordControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdatePasswordControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change Password
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ChangePasswordParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePasswordUsingPOST(authorization: string, xTenantID: string, param: ChangePasswordParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePasswordUsingPOST(authorization, xTenantID, param, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {number} otp 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOTPUsingGET(authorization: string, xTenantID: string, otp: number, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOTPUsingGET(authorization, xTenantID, otp, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UpdatePasswordControllerApi - factory interface
 * @export
 */
export const UpdatePasswordControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdatePasswordControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Change Password
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {ChangePasswordParam} param param
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordUsingPOST(authorization: string, xTenantID: string, param: ChangePasswordParam, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.changePasswordUsingPOST(authorization, xTenantID, param, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail
         * @param {string} authorization token
         * @param {string} xTenantID tenantID
         * @param {number} otp 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOTPUsingGET(authorization: string, xTenantID: string, otp: number, userId: string, options?: any): AxiosPromise<MessageVO> {
            return localVarFp.verifyOTPUsingGET(authorization, xTenantID, otp, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdatePasswordControllerApi - object-oriented interface
 * @export
 * @class UpdatePasswordControllerApi
 * @extends {BaseAPI}
 */
export class UpdatePasswordControllerApi extends BaseAPI {
    /**
     * 
     * @summary Change Password
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {ChangePasswordParam} param param
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdatePasswordControllerApi
     */
    public changePasswordUsingPOST(authorization: string, xTenantID: string, param: ChangePasswordParam, options?: AxiosRequestConfig) {
        return UpdatePasswordControllerApiFp(this.configuration).changePasswordUsingPOST(authorization, xTenantID, param, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail
     * @param {string} authorization token
     * @param {string} xTenantID tenantID
     * @param {number} otp 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdatePasswordControllerApi
     */
    public verifyOTPUsingGET(authorization: string, xTenantID: string, otp: number, userId: string, options?: AxiosRequestConfig) {
        return UpdatePasswordControllerApiFp(this.configuration).verifyOTPUsingGET(authorization, xTenantID, otp, userId, options).then((request) => request(this.axios, this.basePath));
    }
}


